import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
interface HeaderProps {
  onBookConsultation?: () => void;
}
export function Header({
  onBookConsultation
}: HeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-background/95 backdrop-blur-sm shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-110">
      <div className="container mx-auto px-4 md:px-8 flex items-center justify-between h-[60px]" data-id="element-111">
        {/* Logo */}
        <a href="#" className="z-50" data-id="element-112">
          <img src="https://cdn.magicpatterns.com/uploads/pRnQ1zAhJJZDCiS7e6Fgjj/Be_Clinical_logo_navy_hex.png" alt="Be Clinical" className="h-12 w-auto" data-id="element-113" />
        </a>

        {/* Book Now Button */}
        <Button size="sm" onClick={onBookConsultation} data-id="element-114">
          Book Now
        </Button>
      </div>
    </header>;
}